import { gsap } from 'gsap';
function Animate(Sprite, { duration = 3, ScalingFactor = 1.1, ease = 'linear' }) {
  var newHeight = 1.15 * Sprite.height;
  var newWidth = 1.15 * Sprite.width;
  var newX = Sprite.width - newWidth;
  var newY = Sprite.height - newHeight;
  var animation = gsap.to(Sprite, {
    pixi: { height: newHeight, width: newWidth, x: newX, y: newY },
    duration: duration,
    ease: ease,
    paused: true,
  });
  return animation;
}
export default { Animate };
